import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FiscalYearReportByParticipant = _resolveComponent("FiscalYearReportByParticipant")!

  return (_openBlock(), _createBlock(_component_FiscalYearReportByParticipant, {
    title: "Service Unit Report",
    filename: "ServiceUnitReport",
    isSearching: _ctx.isSearching,
    reportData: _ctx.reportData,
    onSearch: _ctx.getReportData
  }, null, 8, ["isSearching", "reportData", "onSearch"]))
}